export const fetchReport = {
  pathname: (id) => `/api/v4/report/${id}`
}

export const fetchNews = {
  pathname: '/api/v4/reports/news'
}

export const fetchPromotedReports = {
  pathname: '/promoted_reports'
}
